// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2w1lZ","clinicsSelect":"TableHeading_clinicsSelect__hPlyf"};